import md5 from 'md5'
import { omit } from './objOperation'
/*
 * 此方法用于平台请求一些方法需要进行签名+验签，
 * params : {
 *  timestamp,
 *  appCode,
 *  _platform, require
 *  _version, require
 *  name,
 *  key
 * }
 */

// todo 这方法名好像不够通用
export function getRequestSign(params = {}, apiSecret = '') {
  // IOS跟Android的apiSecret不一样，如果_platform 跟 IOS跟Android的apiSecret不一样对不上会出现签名错误
  let apiSecretMap = {
    android: '910676770dfc5c34d32e250ea3e91049',
    ios: '6767790dfc5c34d32e250ea3e9104910',
    m: '49da2fb42b5655d69f9449ca2fe30e40',
    pc: '9a9e2bc951b8b9ece1581cc2e78e240d'
  }
  let apiSecret2 = apiSecret
    ? apiSecret
    : apiSecretMap[params._platform || 'ios']
  // 默认值做在里面，让外部只关心name，广告位名称就好了
  let timestamp = new Date().getTime()
  let defaultParams = {
    timestamp
  }
  params = Object.assign(defaultParams, params)
  // let arr = []
  // let timestamp = params["timestamp"];
  if (params['timestamp']) {
    params = omit(params, 'timestamp')
  }

  //字典按key的字母顺序
  let keys = Object.keys(params).sort()
  let paramsStr = ''

  //所有参数名和参数值按顺序拼接一起
  keys.map(key => {
    paramsStr = `${paramsStr}${key}=${params[key]},`
  })

  //拼接apiSecret
  paramsStr = `${paramsStr}${timestamp}${apiSecret2}`
  //md5加密
  let sign = md5(paramsStr) // 小写
  params.timestamp = timestamp
  return { sign, params }
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/platformSign.js